import {FieldValueProps} from '../field/FieldValue';
import {widgetProps} from '../widgets/common';
import {DateWidget} from '../widgets/DateWidget';
import React from 'react';
import {useIntl} from 'react-intl';
import {useOnChange} from './hooks/useOnChange';
import {useBusinessDayStartTimeMinutes} from './hooks/useBusinessDayStartTimeMinutes';

type Props = FieldValueProps;

export function DateRangeField(props: Props): JSX.Element | null {
  const intl = useIntl();
  const field = props.field;

  const startId = widgetProps<string>(props.field, 'start_field_id', '');
  const startValue = props.values[startId];

  const endId = widgetProps<string>(props.field, 'end_field_id', '');
  const endValue = props.values[endId];

  const onChangeStart = useOnChange(props.onChange, startId);
  const onChangeEnd = useOnChange(props.onChange, endId);

  const pf = widgetProps(
    field,
    'placeholder_start',
    intl.formatMessage({id: 'Field.DateFilter.From', defaultMessage: 'From'}),
  );
  const pt = widgetProps(
    field,
    'placeholder_end',
    intl.formatMessage({id: 'Field.DateFilter.To', defaultMessage: 'To'}),
  );

  const minutes = useBusinessDayStartTimeMinutes(props.field);

  return (
    <>
      <DateWidget
        value={startValue}
        onChange={onChangeStart}
        readOnly={false}
        placeholder={pf}
        businessDayStartTimeMinutes={minutes}
      />
      <DateWidget
        value={endValue}
        onChange={onChangeEnd}
        readOnly={false}
        placeholder={pt}
        style={{marginTop: '0.5rem'}}
        businessDayStartTimeMinutes={minutes}
      />
    </>
  );
}
